// This file is auto-updated to verify deployment versions
// Update the timestamp below before each build to track versions
export const BUILD_INFO = {
  timestamp: '2026-03-30T00:00:00',
  version: '3.26.0-spa-routing-fix',
  feature: 'SPA routing fix for page refresh 404s'
};
